<template src="./ZaloServiceComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {useAccountStore} from "@/stores/account.js";
import {AppConstant, CommonText} from "@/supports/app.constant";
import {ref, onMounted, computed, watch, reactive} from "vue";
import CommonService from "@/services/common.service.ts";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import {useRouter} from "vue-router";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
import {useProductStore} from "@/stores/product.js";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import SelectCustom from "@/components/inputs/select/custom/SelectCustom.vue";
import ModalDeliveryProductListComponent
  from "@/components/modals/modal-delivery-product-list/ModalDeliveryProductListComponent.vue";
import ModalProductExportComponent from "@/components/modals/modal-export/ModalExportComponent.vue";
import LoadingComponent from "@/components/loading/LoadingComponent.vue";
import ModalProductImportComponent from "@/components/modals/modal-product-import/ModalProductImportComponent.vue";
import ModalExportComponent from "@/components/modals/modal-export/ModalExportComponent.vue";
import {useScreenSize} from "@/composable/useScreenSize.js";
import {useSyncZalo} from "@/stores/syncZalo.js";
import ErrorMessageService from "@/services/error-message.service.js";
import IconImage from "@/components/icons/IconImage.vue";
import ModalUserZaloDetailComponent from "@/components/modals/modal-user-zalo-detail/ModalUserZaloDetailComponent.vue";

export default {
  name: 'ZaloServiceComponent',
  components: {
    ModalUserZaloDetailComponent,
    IconImage,
    ModalExportComponent,
    ModalProductImportComponent,
    LoadingComponent,
    ModalProductExportComponent,
    ModalDeliveryProductListComponent,
    SelectCustom,
    InputCheckboxOne,
    PaginateComponent,
    ButtonAddComponent,
    IconTrash,
    IconEdit,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome},
  setup() {
    const dataHeaderTable =  ref({
      userName: {
        label: 'Tên người dùng',
        order: 1,
        width: '15%',
      },
      avatar: {
        label: 'Ảnh đại diện',
        order: 2,
        width: '5%',
      },
      user_is_follower: {
        label: 'Trạng thái quan tâm OA',
        order: 3,
        width: '5%',
      },
      user_last_interaction_date: {
        label: 'Ngày cuối tương tác tới OA',
        order: 4,
        width: '5%',
      },
      action: {
        label: '',
        order: 5,
        width: '10%',
      },
    })
    const labelButtonSearch = ref('Tìm kiếm')
    const labelButtonSyncZalo = ref('Đồng bộ người theo dõi')
    const urlOrigin = ref('/product/list/')
    const dataSearch = ref({
      username: {
        id: 'username',
        label: 'Tên sản phẩm',
        placeholder: 'Tên sản phẩm',
        value: '',
        required: false
      },
    })
    const checkAll = ref(false)
    const checkItems = ref({})
    const listItemSelected = ref([])
    const eventClickShowModal = ref(false)
    const isLoading = ref(false)
    const userDetail = ref({})
    const messError = ref('')
    const errorMessage = ref([])
    const location = ref('Sản phẩm')
    const table = ref('product')
    const { widthScreen, isSmallScreen } = useScreenSize(1024);
    const selectAction = ref(CommonService.showDropdownAction(AppConstant.DROPDOWN_ACTION_PRODUCT))
    const selectLimitPage = ref(CommonService.showDropdownAction(AppConstant.DROPDOWN_ACTION_PAGE))

    const stateModal = reactive({
      modalUserZaloDetail: null,
    })
    const accountStore = useAccountStore()
    const syncZaloStore = useSyncZalo()
    const router = useRouter()

    onMounted(() => {
      stateModal.modalUserZaloDetail = new bootstrap.Modal('#modalUserZaloDetail', {})
      getListUsersZalo(router.currentRoute.value.query.page ?? 1);
    });

    const listUsersZalo = computed(() => {
      return syncZaloStore.usersZalo;
    });
    const paginate = computed(() => {
      return syncZaloStore.paginate;
    });

    watch(() => syncZaloStore.isLoading, (newIsLoading) => {
      isLoading.value = newIsLoading
    });

    async function syncZaloUser() {
      const params = {
        id: accountStore.account.company.id,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/user-zalo/sync-list-followers/' + accountStore.account.company.id;
      const res = await syncZaloStore.syncListFollowers(url, params);
      const errorMessageRes = await ErrorMessageService.getErrorMessage(res)
      if(errorMessageRes !== undefined && errorMessageRes.length > 0) {
        errorMessage.value = typeof errorMessageRes === 'string' ? [errorMessageRes] : errorMessageRes;
      } else {
        await CommonService.showAlertPopup({
          title: res?.message,
          icon: res?.status,
          showConfirmButton: false,
          timer: 1200,
          width: '800px'
        });
        await router.push('/third-party/zalo/user')
      }
    }

    function emitPage(page) {
      getListUsersZalo(page);
    }
    function redirectToCreate() {
      router.push('/product/create')
    }

    async function getListUsersZalo(page, take = 10) {
      const params = {
        company_id: accountStore.account.company.id,
        id: syncZaloStore.syncZalo.id,
        username: dataSearch.value.username.value,
        page: page,
        take: take,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/user-zalo/list';
      await syncZaloStore.getListUsersZalo(url, params);
    }

    async function sendInviteCooperate(followId) {
      const params = {
        company_id: accountStore.account.company.id,
        sync_id: syncZaloStore.syncZalo.id,
        follow_id: followId,
        type: AppConstant.TYPE_MESSAGE_ZALO_INVITE_PARTNER,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/message-zalo/send-message';
      const res = await syncZaloStore.sendInviteCooperate(url, params);
      const errorMessageRes = await ErrorMessageService.getErrorMessage(res)
      if(errorMessageRes !== undefined && errorMessageRes.length > 0) {
        errorMessage.value = typeof errorMessageRes === 'string' ? [errorMessageRes] : errorMessageRes;
      } else {
        await CommonService.showAlertPopup({
          title: res?.message,
          icon: res?.status,
          showConfirmButton: false,
          timer: 1200,
          width: '800px'
        });
        syncZaloStore.usersZalo = syncZaloStore.usersZalo.map((item) => {
          if (item.id === followId) {
            return {
              ...item,
              partner: {
                ...(item.partner || {}),
                status: AppConstant.PARTNER_STATUS_INVITE,
              },
            };
          }
          return item;
        });
      }
    }

    function searchProducts() {
      getListUsersZalo(1);
    }

    function onChange(value, name) {
      dataSearch.value[name].value = value;
    }

    async function actionLimitPage(key) {
      switch (parseInt(key)) {
        case AppConstant.LIMIT_PAGE_10:
          await getListUsersZalo(1, AppConstant.LIMIT_PAGE_10);
          break;
        case AppConstant.LIMIT_PAGE_20:
          await getListUsersZalo(1, AppConstant.LIMIT_PAGE_20);
          break;
        case AppConstant.LIMIT_PAGE_50:
          await getListUsersZalo(1, AppConstant.LIMIT_PAGE_50);
          break;
      }
    }

    function showUserDetail(userId) {
      const userSelected = syncZaloStore.usersZalo.find((item) => item.follower_id === userId)
      userDetail.value = userSelected.profile ?? {}
      if (userDetail.value) {
        userDetail.value.avatar = userDetail.value.avatars?.['240'] || userDetail.value.avatar;
      }

      eventClickShowModal.value = true
      isLoading.value = true
    }

    function showErrorMessage(mess) {
      messError.value = mess
    }

    function eventShowModal(isShow) {
      if(isShow) {
        setTimeout(function () {
          eventClickShowModal.value = false
          isLoading.value = false
          stateModal.modalUserZaloDetail.show()
        }, 1000);
        return;
      }
      stateModal.modalUserZaloDetail.hide()
    }

    function removeError() {
      messError.value = ''
    }

    return {
      listUsersZalo,
      dataHeaderTable,
      labelButtonSearch,
      labelButtonSyncZalo,
      dataSearch,
      paginate,
      urlOrigin,
      checkAll,
      listItemSelected,
      checkItems,
      selectAction,
      selectLimitPage,
      isLoading,
      messError,
      location,
      table,
      widthScreen,
      isSmallScreen,
      userDetail,
      sendInviteCooperate,
      emitPage,
      redirectToCreate,
      searchProducts,
      onChange,
      eventClickShowModal,
      eventShowModal,
      actionLimitPage,
      showErrorMessage,
      removeError,
      showUserDetail,
      syncZaloUser,
      CommonText,
      CommonService,
    }
  },
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 265px;
  height: 100%;
  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }
  .container-fluid {
    padding-top: 30px;
    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46,35,94,.07);
      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;
        .btn-invite-partner {
          width: 150px;
          margin-top: 50px;
        }
        .list-partners-component {
          margin-top: 30px;
          .label_priority {
            padding: 5px;
            border: 1px solid #f73164;
            border-radius: 5px;
            max-width: 120px;
            width: 120px;
            display: flex;
            align-content: center;
            justify-content: center;
            color: #ffffff;
          }
          td.action {
            display: flex;
            justify-content: center;
            gap: 20px;
            .item-action {
              width: 20px;
              cursor: pointer;
            }
          }
          td.user-zalo-name {
            max-width: 500px;
            p {
              overflow-y: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              line-clamp: 1;
              -webkit-box-orient: vertical;
              margin: 0;
              text-decoration: underline;
              cursor: pointer;
            }
          }
        }

      }
    }
  }
}
</style>